"use client";

import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";

export type StageDotProps = {
  /** Hex from `StageResponse.color`; falls back to a neutral stage glyph. */
  color?: string | null;
  className?: string;
  /** Size of the fallback glyph, to sit right in the row it's rendered in. */
  iconSize?: number;
  iconClassName?: string;
};

/**
 * A stage's colour swatch. Shared by every stage picker so the same stage reads
 * the same everywhere: the add-to-job select, the import stage input, and the
 * pipeline filter panel.
 */
export function StageDot({
  color,
  className,
  iconSize = 16,
  iconClassName,
}: StageDotProps) {
  if (color) {
    return (
      <span
        className={cn("size-2 shrink-0 rounded-full", className)}
        style={{ backgroundColor: color }}
      />
    );
  }
  return (
    <Icon
      name="IconPlan"
      size={iconSize}
      className={cn("shrink-0 text-heading opacity-40", iconClassName)}
    />
  );
}
